import React from 'react';

import MaterialTable from 'material-table';
import { KeyboardDatePicker } from "@material-ui/pickers";
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Sync as SyncIcon, Close as CloseIcon, LocalShipping as TruckIcon } from '@material-ui/icons';
import { Button, Dialog, Select, TextField, Typography, IconButton, DialogTitle, 
         DialogActions, DialogContent, FormControl, InputLabel, Paper } from '@material-ui/core';

import Awb from '../../../models/Awb';
import AwbPart  from '../../../models/AwbPart';

import Moment from 'moment';

import addAWBModalStyles from './addAWBModal.module.css';
import commonStyles from '../../common/common.module.css';

import tableIcons from '../../../utils/editTableIcons';
import { UserRoleType } from '../../../models/User';
import AirlineType from '../../../models/AirlineType';

const iconFontSize = 20;
const TEXT_FIELD_PADDINGS: string = '6px 12px';
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      color: 'rgba(0, 0, 0, 0.87)',
      '&:hover': {
        cursor: 'pointer',
      }
    },
    dialogPaper: {
      width: '100%',
    },
    wrapper: {
      paddingTop: '25px',
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    input: {
      fontSize: '0.8125rem',
      fontWeight: 400,
    },
    marginTop1px: {
      marginTop: '1px'
    },
    marginBottomMinus7px: {
      marginBottom: '-7px'
    },
    selectStatusStyle: {
      width: '170px',
      fontSize: '0.8125rem'
    },
    selectFlightStyle: {
      width: '70px',
      fontSize: '0.8125rem',
      textAlign: 'right'
    },
    buttonsWrapper: {
      margin: '0 2% 20px 2.5%'
    },
    close: {
      marginTop: '10px'
    },
    actionStyle: {
      '& .MuiTableSortLabel-root-314': {
        '&:hover': {
          cursor: 'text',
          color: 'white'
        }
      }
    },
    table: {
      border: '1px solid rgba(0, 0, 0, 0.1)'
    },
    datePick: {
      marginTop: 16,
      height: 32,
      width: 165
    },
    selectFirstFlightOut: {
      width: '100%'
    },
    textFieldShipper:{
      width: '100%',
    },
    textFieldCommodity:{
      width: '100%',
    },
    selectCcsf: {
      width: '33.7%',
      marginTop: 15
    },
    inputTextField: {
      '& [disabled] ': {
        color: 'var(--primaryblue)',
        textAlign: 'center'
      }
    }
  });

interface AddAWBModalProps {
  classes: any;
  errorMsg: any;
  awb: Awb;
  userRole: UserRoleType;
  edited: boolean;
  handleChange: (propertyName: string, event: any) => void;
  onValidationPcs: any;
  onValidationWgt: any;
  handleClose: (modalType: string) => void;
  handleSync?: Function;
  modalOpen: boolean;
  setState: Function;
  enableCartIcon: Function;
  addPartToCart: Function;
  handleValidationBeforeSave: () => void;
  errorClose: string;
  availableAwbPartStatusesForProcess: string[];
  shipperProfileOptions: Array<string>;
  shipperProfileError: boolean;
  ccsfOptions: Array<string>;
  ccsf: { ccsfDisabled: boolean; ccsfIndex: number; ccsfError: boolean; };
  awbActionOfUpdateButton: 'add' | 'update';
  valueFirstFlightOut: string;
  firstFlightOutPossible: Array<string>;
  manualEntry?: boolean;
  airlines: AirlineType[];
  awbInfo?: boolean;
  managerAccess: boolean;
  disableUpdate?: boolean;
};

const addAWBModal = ( props: AddAWBModalProps ) => {

  const { classes } = props;
  const airlineOptions = props.airlines.map((airline: AirlineType) => {
    return (<option value={ airline.iata_code } key={ airline.id }>{ airline.iata_code }</option>);
  });
  const allowedAwbUpdateAction: boolean = props.awb.allowed_ops.update_awb;
  const disabledOriginAndDestination: boolean = !props.awb.manually_entered || !allowedAwbUpdateAction;

  const errorPart: JSX.Element = (
    props.errorClose !== '' ? <div className={ addAWBModalStyles.errorClose }>{ props.errorClose }</div> :
    <span className={ addAWBModalStyles.errorPart }>
      <p>{ props.errorMsg.add }</p> 
      <p>{ props.errorMsg.pieces }</p> 
      <p>{ props.errorMsg.weight }</p> 
    </span>
  );
    
  const classNameValPcs: string = props.errorMsg.pieces ? `${ addAWBModalStyles.validation } ${ addAWBModalStyles.textField }` : `${ addAWBModalStyles.textField }`;
  const classNameValWeight: string = props.errorMsg.weight ? `${ addAWBModalStyles.validation } ${ addAWBModalStyles.textField }` : `${ addAWBModalStyles.textField }`;
  const disableUpdateOptions: boolean = props.awbActionOfUpdateButton === 'update' ? !props.awb.allowed_ops.update_awb : false;
  const disableUpdate: boolean = props.disableUpdate || false;
   
  const title = (
    <div>
      <div className={ addAWBModalStyles.headerTitleContainer} >
        <span className={ addAWBModalStyles.headerTitle }>Verify Shipment Details</span>
        <IconButton aria-label="Close" className={ classes.close } onClick={ () => props.handleClose('export') }>
          <CloseIcon color='primary' />
        </IconButton>
      </div>
      <div className={ addAWBModalStyles.awbDetails }>
        <div className={ addAWBModalStyles.awbWrapper }>
          <span>
          { !props.awb.edited && props.handleSync && !props.edited  && allowedAwbUpdateAction
            ? <Typography className={ addAWBModalStyles.iconText }><SyncIcon className={ [ classes.materialIcon, classes.marginBottomMinus7px ].join(' ') } onClick={ ()=> props.handleSync!(props.awb.code, props.awb.number) } />Auto updated</Typography>
            : !props.manualEntry ?
                <Typography><SyncIcon className={ [ classes.disabledIcon, classes.marginBottomMinus7px ].join(' ') } />{ props.awb.edited? 'Manually updated': 'Auto updated' }</Typography>
            : null
            }
          </span>
          <span className={ addAWBModalStyles.text }>{ props.awb.code }-{ props.awb.number }</span>
        </div>
        <div className={ `${ addAWBModalStyles.awbDetailsWrapper } ${props.manualEntry ? '' : addAWBModalStyles.awbDetailsWrapperManual }` }>
          {
            props.manualEntry ?
            <div className={ `${ addAWBModalStyles.pcsWgh } ${ addAWBModalStyles.pcsWghWrapper }` }>Pcs: {props.awb.pieces}</div>
            :
            <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
              <p className={ addAWBModalStyles.pcsWgh }>Pcs:</p>
              <TextField
                id="pieces"
                className={ classNameValPcs }
                value={ props.awb.pieces }
                onChange={ () => props.handleChange('pieces', event) }
                onBlur={ props.onValidationPcs } 
                error={ !props.awb.pieces || isNaN(+props.awb.pieces) || +props.awb.pieces <= 0 }
                helperText={ (!props.awb.pieces || isNaN(+props.awb.pieces) || +props.awb.pieces <= 0) ? 'Add AWB Pcs' : '' }
                disabled={ !allowedAwbUpdateAction  }
                InputProps={{ className: classes.inputTextField, disableUnderline: !allowedAwbUpdateAction  }}
                />
            </div>
        }
        {
          props.manualEntry ?
            <div className={ `${ addAWBModalStyles.pcsWgh } ${ addAWBModalStyles.pcsWghWrapper }` }>Wgt: {props.awb.weight? parseFloat(props.awb.weight).toFixed(1) : '0.0'}K</div>
          :
          <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
            <p className={ addAWBModalStyles.pcsWgh }>Wgt:</p>
            <TextField
              id="weight"
              className={ classNameValWeight }
              value={ props.awb.weight }
              onChange={ () => props.handleChange('weight', event) }
              onBlur={ props.onValidationWgt }
              error={ !props.awb.weight || isNaN(+props.awb.weight) || +props.awb.weight <= 0 }
              helperText={ (!props.awb.weight || isNaN(+props.awb.weight) || +props.awb.weight <= 0) ? 'Add AWB Wgt' : '' }
              disabled={ !allowedAwbUpdateAction || props.manualEntry }
              InputProps={{ className: classes.inputTextField, disableUnderline: !allowedAwbUpdateAction  }}
            />
          </div>
        }
        <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
          <p className={ addAWBModalStyles.pcsWgh }>Org:</p>
          <TextField
            id="origin"
            autoFocus={props.manualEntry}
            className={ addAWBModalStyles.textField }
            value={ props.awb.origin }
            onChange={ () => props.handleChange('origin', event) }
            error={ !props.awb.origin }
            helperText={ !props.awb.origin ? 'Add Org': '' }
            disabled={!props.managerAccess ? disabledOriginAndDestination : false}
            InputProps={{ className: classes.inputTextField, disableUnderline: disabledOriginAndDestination }}
          />
          </div>
          <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
            <p className={ addAWBModalStyles.pcsWgh }>Dest:</p>
            <TextField
              id="destination"
              className={ addAWBModalStyles.textField }
              value={ props.awb.destination }
              onChange={ () => props.handleChange('destination', event) }
              error={ !props.awb.destination }
              helperText={ !props.awb.destination ? 'Add Dest': '' }
              disabled={!props.managerAccess ? disabledOriginAndDestination : false}
              InputProps={{ className: classes.inputTextField, disableUnderline: disabledOriginAndDestination }}
            />
          </div>
        </div>
      </div>
      <hr className={ addAWBModalStyles.hrStyle } />
      { errorPart }
    </div> 
  );
    
  return (
    <Dialog open={ props.modalOpen } onClose={ () => props.handleClose('export') } aria-labelledby="form-dialog-title" maxWidth={ 'md' } classes={{ paper: classes.dialogPaper }}>

      <DialogTitle id="form-dialog-title">{ title }</DialogTitle>
      <DialogContent className={ classes.actionStyle }>
        
        <div className={ commonStyles.wrapper } >
          <h3 className={ `${ commonStyles.header } ${ commonStyles.w100 }` }>Details </h3>
          <div className={ [addAWBModalStyles.inputsWrapper,addAWBModalStyles.Wrapper].join(" ")} >

            <div className={ addAWBModalStyles.firstFlightWrapper } >
              <div className={ commonStyles.label }>First Flight Out</div>
      
              <Select native
                value={ props.valueFirstFlightOut }
                onChange={ () => props.handleChange('firstFlightOut', event) }           
                className={ classes.selectFirstFlightOut }
              >
                {
                  props.firstFlightOutPossible.map((item: string, index: number) => {
                    return <option key= {index } value={ item }>{ item }</option>
                      
                    })
                }
                </ Select>

            </div>

            <div className={ addAWBModalStyles.shipperWrapper }>

              <div className={ commonStyles.label }>Shipper</div>
              <TextField
                variant="standard"
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                  className={ classes.textFieldShipper }
                  value={ props.awb.export_metadata.shipperName }
                  onChange={ () => props.handleChange('shipperName', event) }
                />

            </div>
            
            <div className={ addAWBModalStyles.commodityWrapper }>
              
              <div className={ commonStyles.label }>Commodity</div>
              <TextField
                className={ classes.textFieldCommodity }
                value={ props.awb.export_metadata.comodityType }
                onChange={ () => props.handleChange('commodity', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
              />

            </div>
          </div>
        </div>


        <div className={ `${ commonStyles.wrapper } ${ classes.wrapper }` } >
          <h3 className={ `${ commonStyles.header }` }> Booking information </h3>
          <MaterialTable 

            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

            icons={ tableIcons }

            columns = {[
              { title: 'Flight', field: 'flight',
              render: (rowData: any) => {
                const flightDate: string = rowData.flight_date ? `/${Moment(rowData.flight_date).format('DD-MMM').toUpperCase()}` : '';
                const flight: string = rowData.flight ? rowData.flight_no + flightDate  : '';
                return <span className={[classes.selectFlightStyle, addAWBModalStyles.flightCol].join(" ")}>{ flight }</span>;
              },
                editComponent: (editProps: any) => {

                  return <div>
                            { props.userRole !== 'fwd' ? 
                              <Select
                                native
                                id="airlineValue"
                                name="airlineValue"
                                onChange={ e => editProps.onChange(e.target.value) } 
                                className={classes.selectFlightStyle}
                                value={ editProps.rowData.flight }
                              >
                                <option value='' />
                                { airlineOptions }
                              </Select> : 
                              <TextField
                                value={ editProps.rowData.flight }
                                placeholder="Airline Code"
                                InputProps={{ className: classes.inputTextFieldTable }}
                                className={ addAWBModalStyles.flight_no }
                                onChange={ e => editProps.onChange(e.target.value) } 
                              />
                            }
                        
                        </div>
                },
                cellStyle: { paddingRight: 0, paddingLeft: 0, textAlign: 'center', width: '35px' }, 
                headerStyle: { maxWidth: '5px', paddingRight: 0, paddingLeft: '22px', textAlign: 'center', width: '20%' }
              },
              { title: '', field: 'number',
              render: () => (
                null
              ),
              editComponent: (props: any) => {

                return (
                  <TextField
                    autoFocus={ true }
                    value={ props.value }
                    placeholder="Flight No"
                    InputProps={{ className: classes.input }}
                    className={ addAWBModalStyles.flight_no }
                    onChange={ e => props.onChange(e.target.value) } 
                    type='number'    
                  />
                )
              },
              cellStyle: { paddingRight: 0, paddingLeft: 0, textAlign: 'left', width: '25px' },
              headerStyle: { maxWidth: 0, paddingRight: 0, paddingLeft: 0, textAlign: 'left', width: '15%' }
            },
              { title: '', field: 'flight_date',
                render: (rowData: any) => {

                  return null;
                },
                editComponent: (props: any) => {
                  return <KeyboardDatePicker
                            value={ props.value ? props.value : null }
                            format={ 'DD-MMM-YY' }
                            placeholder="Flight Date"
                            InputProps={{ className: classes.input }}
                            className={ classes.datePicker }
                            onChange={ (e: any) => {
                              const newDate: string = Moment(e._d).format('YYYYMMDD');
                              props.onChange(newDate);
                            }}
                            fullWidth
                            autoOk
                          />;
                },
                cellStyle: { paddingLeft: 0, paddingRight: '10px' },
                headerStyle: { paddingRight: 0, paddingLeft: 0, width:'15%' }
              },
              { title: 'Pcs', field: 'pieces', cellStyle: { width: '7%' }, headerStyle: { paddingRight: 0, paddingLeft: 0, width: '7%' } },
              { title: 'Wgt', field: 'weight',headerStyle: { width:'10%' }, cellStyle: { width:'10%' },
                render: (rowData: AwbPart) => {
                  const weight: number = +(rowData.weight);
                  return (<span>{weight.toFixed(1)}K</span>)
              }},
              { title: 'Status', field: 'status',headerStyle: { width:'30%' },
              editComponent: (editComponentProps: any) => {

                return (<Select native
                  value={editComponentProps.value || ''}
                  onChange={ e => {
                    editComponentProps.onChange(e.target.value);
                  } }
                  className={classes.selectStatusStyle}>
                  <option value=""></option>
                  {props.availableAwbPartStatusesForProcess.map((status: string) => <option value={status} key={status}>{status}</option>)}
                </Select>);
              }
            }
            ]}

            data = { props.awb.export_parts }
          
            editable = {  allowedAwbUpdateAction  ? {
              
              onRowUpdate: (newData: any, oldData: any) =>
                new Promise<void>((resolve, reject) => {

                  if (newData.number === '' || newData.flight === '' || !newData.flight || newData.pieces === '' || newData.weight === '' || newData.flight_date === '' || 
                    (+newData.pieces<=0) || +newData.weight<=0 || isNaN(newData.pieces) || isNaN(newData.weight)) {

                    props.setState({ errorMsg: { ...props.errorMsg, add: 'The field is empty or in incorrect format!' } });
                    reject();

                    let cancel: HTMLSpanElement | null = document.querySelector("span[title='Cancel']");

                    if (cancel) {
                      cancel.addEventListener("click", () => {
                        props.setState({ errorMsg: { ...props.errorMsg, add: '' } } );
                      });
                    }

                    return;
                  } else {
                    props.setState({ errorMsg: { ...props.errorMsg, add: '' } });

                    setTimeout(() => {
                      {
                        const awb: Awb = { ...props.awb }; 
                        const parts: AwbPart[] = [...props.awb.export_parts]; 
                    
                        newData.flight_no = newData.flight + newData.number;
                        const index: number = parts.indexOf(oldData);

                        parts[index] = newData;
                        awb.export_parts = parts;
                        props.setState({ awb }, () => resolve());
                        props.onValidationPcs();
                        props.onValidationWgt();
                      }
                      resolve();
                    }, 1000);
                  }
              }),
              onRowDelete: (oldData: any) =>
                new Promise<void>((resolve, reject) => {
          
                  setTimeout(() => {
                    {
                      const awb: Awb = { ...props.awb }; 
                      const parts: AwbPart[] = [...props.awb.export_parts]; 
                      const index: number = parts.indexOf(oldData);

                      parts.splice(index, 1);
                      awb.export_parts = parts;

                      props.setState({ awb}, () => resolve());
                      props.onValidationPcs();
                      props.onValidationWgt();
                    }
                    resolve();
                  }, 1000);
              }),
            }: undefined }

            actions = {[
              (rowData: any) => ({
                icon: () => props.enableCartIcon(rowData) && props.awb.allowed_ops.add_awb_truck && props.awbActionOfUpdateButton !== 'add'
                  ? <TruckIcon className={ [classes.materialIcon, classes.marginTop1px ].join(' ') } />
                  : <TruckIcon className={ [classes.disabledIcon, classes.marginTop1px ].join(' ') } />,
                tooltip: 'Group for drop off',
                disabled: props.awbActionOfUpdateButton === 'add',
                onClick: props.enableCartIcon(rowData) ? (event, rowData: any) => props.addPartToCart(rowData) : () => {}
              })
            ]}

            options = {{
              showTitle: false,
              toolbar: false,
              sorting: false,
              search: false,
              paging: false,
              actionsColumnIndex: -1,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2
              }      
            }}
          />
        </div>
      </DialogContent>

      <DialogActions className={ classes.buttonsWrapper } >
        <Button onClick={() => { props.edited ?  props.handleValidationBeforeSave() : props.handleClose('export') }} color="primary" disabled={ disableUpdate } variant="contained">Update</Button>    
      </DialogActions>

    </Dialog>
  );
};

export default withStyles(styles)(addAWBModal);